import React, { Fragment, useEffect, useState } from "react";
import DevelopmentTree from "./developmentTree"
import GoalForm from "./GoalForm";

const goalsList = {
    display: 'flex',
    listStyleType: 'none',
    paddingInlineStart: 0,
    justifyContent: 'center',
    flexWrap: 'wrap',
    margin: 0
}

export default function Goals({ user, project }) {
    const [index, setIndex] = useState(0);
    const { projectId } = project;
    const [goals, setGoals] = useState(undefined);
    const [show, setShow] = useState(false);
    // creating a local copy of goals to update them or change without fetching from database
    useEffect(() => {
        setGoals(project.goals)
    }, [project])

    const numOfgoals = goals ? goals.length : 0;
    //console.log('project:', project);
    return (
        <div >
            <h2 style={{ textAlign: 'center' }}>Goals</h2>
            <ul style={goalsList}>
                {goals?.map((goal, i) => // if goals are defined map all goals
                    <li key={goal?.name} style={{ marginBlockEnd: 0 }}>
                        <button onClick={() => { setIndex(i); }} className="popUp"
                            style={{
                                background: 'var(--mdGray)',
                                margin: '3px',
                                padding: '2px 10px',
                                borderRadius: 15,
                                color: i === index ? 'var(--white)' : 'var(--orng)'
                            }}>
                            <h3 style={{ margin: 0, fontSize: 20, }}>{goal?.name}</h3>
                        </button>
                    </li>
                )}
                {user && // if user is logged in render a new goal button
                    <li key='new' style={{ marginBlockEnd: 0 }}>
                        <button onClick={() => {
                            setIndex(numOfgoals);
                            setShow(true)
                        }} className="popUp"
                            style={{
                                background: 'var(--mdGray)',
                                margin: '3px',
                                padding: '2px 10px',
                                borderRadius: 15,
                                color: numOfgoals === index ? 'var(--white)' : 'var(--orng)'
                            }}>
                            <h3 style={{ margin: 0, fontSize: 20, }}>New +</h3>
                        </button>
                    </li>}
            </ul>
            {(goals || show) &&
                <Fragment>
                    <hr />
                    {(user ? // if user is logged in render an editable goal form
                        <GoalForm goals={goals} setGoals={setGoals} projectId={projectId} index={index} setIndex={setIndex} />
                        : // otherwise render static goals info
                        <div style={{ display: 'grid', gridTemplateColumns: 'auto auto', placeItems: "center" }}>
                            <p>{goals[index]?.desc}</p>
                            {goals && goals[0]?.completion && <DevelopmentTree index={index} goals={goals} completion={goals[index].completion} />}
                        </div>)}
                </Fragment>
            }
        </div>
    )
}